<template>
	<v-flex>
		<v-text-field
			:prepend-icon="$props.prependicon"
			:counter="$props.counter"
			:maxLength="$props.counter"
			:error-messages="$props.error"
			:hint="$props.hint"
			:label="$props.label"
			:mask="$props.mask"
			:placeholder="' '"
			:readonly="$props.readonly"
			:rules="$props.rules"
			:type="$props.type"
			class="ml-2 mr-2"
			v-if="!isSimple"
			v-model="inputValue"></v-text-field>
		<v-text-field
			:prepend-icon="$props.prependicon"
			:counter="$props.counter"
			:maxLength="$props.counter"
			:mask="$props.mask"
			:placeholder="$props.placeholder"
			:readonly="$props.readonly"
			:rules="$props.rules"
			:type="$props.type"
			class="simple" hide-details
			v-if="isSimple"
			v-model="inputValue"></v-text-field>
	</v-flex>
</template>

<script>
	export default {
		name: "InputField",
		props: ['rules', 'readonly', 'simple', 'value', 'error', 'placeholder', 'label', 'type', 'mask', 'hint', 'counter', 'prependicon'],
		data() {
			return {
				inputValue: this.$props.value
			}
		},
		computed: {
			isSimple() {
				return (typeof this.$props.simple !== 'undefined');
			}
		},
		watch: {
			inputValue() {
				this.$emit('input', this.inputValue);
			},
			value() {
				this.inputValue = this.$props.value;
			}
		}
	}
</script>

<style scoped>
	.simple {
		padding: 0px;
		margin: 0px;
	}
</style>
